<template>
  <DxForm id="formularioServicioEnergia" ref="formInstance" :form-data="model" label-location="top"
  :show-colon-after-label="false" :visible="model != null" validation-group="validacionServicioEnergia">
    <!-- xs: 768, sm: 992, md:1200 -->
    <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

    <!-- Datos del servicio -->
    <DxGroupItem :col-span="6" :col-count="6">
      <DxSimpleItem data-field="EmpresaServicios" editor-type="dxTextBox" :col-span="3" :editor-options="{ readOnly: true }">
        <DxLabel :text="$t('servicio_energia.form.nombre_empresa_servicios')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Activa" :col-span="3" css-class="activa-checkbox">
        <DxCheckBox v-model="props.model!.Activa" :text="$t('servicio_energia.form.activa')" />
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="3" ">
        <DxLabel :text="$t('servicio_energia.form.nombre')" />
        <DxRequiredRule :message="$t('servicio_energia.form.validacion.nombre')" :reevaluate="true" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="3"></DxEmptyItem>
      <DxSimpleItem data-field="FechaInicio" editor-type="dxDateBox" :col-span="2"
        :editor-options="{ readOnly: tieneTramitesAsociados }">
        <DxLabel :text="$t('servicio_energia.form.fecha_inicio')" />
        <DxRequiredRule :message="$t('servicio_energia.form.validacion.fecha_inicio')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="FechaFin" editor-type="dxDateBox" :col-span="2" :is-required="true">
        <DxDateBox v-model="props.model!.FechaFin" validation-message-mode="always">
          <DxValidator ref="validatorFechaFin" validation-group="validacionFechaFin">
            <DxRequiredRule :message="$t('servicio_energia.form.validacion.fecha_fin')" />
            <DxCompareRule :comparison-target="fechaInicio" :comparison-type="'>'"
              :message="$t('servicio_energia.form.validacion.fecha_fin_mayor')" :reevaluate="true" />
          </DxValidator>
        </DxDateBox>
        <DxLabel :text="$t('servicio_energia.form.fecha_fin')" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="2"></DxEmptyItem>
      <DxSimpleItem data-field="TipoEnergia" editor-type="dxSelectBox" :col-span="2" :editor-options="selectTipoEnergia">
        <DxLabel :text="$t('servicio_energia.form.tipo_energia')" />
        <DxRequiredRule :message="$t('servicio_energia.form.validacion.tipo_energia')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Coste" editor-type="dxNumberBox" :col-span="2" :editor-options="costeNumberOptions">
        <DxLabel :text="$t('servicio_energia.form.coste')" />
        <DxRequiredRule :message="$t('servicio_energia.form.validacion.coste')" />
        <DxCompareRule :comparison-target="() => 0" :comparison-type="'>'"
          :message="$t('servicio_energia.form.validacion.coste_mayor_cero')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Excluyente" :col-span="2" css-class="excluyente-checkbox"> 
        <DxCheckBox v-model="props.model!.Excluyente" :text="$t('servicio_energia.form.excluyente')" 
          :read-only="tieneTramitesAsociados" class="excluyente" />
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxSimpleItem data-field="Descripcion" editor-type="dxTextArea" :col-span="6" :editor-options="descripcionOptions">
        <DxLabel :text="$t('servicio_energia.form.descripcion')" />
        <DxRequiredRule :message="$t('servicio_energia.form.validacion.descripcion')" />
      </DxSimpleItem>
      <DxSimpleItem data-field="AplicaPersonaFisica" :col-span="2">
        <DxCheckBox v-model="props.model!.AplicaPersonaFisica" :read-only="tieneTramitesAsociados"
          :text="$t('servicio_energia.form.aplica_persona_fisica')" validation-message-mode="always"
          validation-message-position="right">
          <DxValidator ref="validatorTipoPersona" validation-group="validacionTipoPersona">
            <DxCustomRule :validation-callback="validarTipoPersona" message="" :reevaluate="true" />
          </DxValidator>
        </DxCheckBox>
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxSimpleItem data-field="AplicaPersonaJuridica" :col-span="2">
        <DxCheckBox v-model="props.model!.AplicaPersonaJuridica" :read-only="tieneTramitesAsociados"
          :text="$t('servicio_energia.form.aplica_persona_juridica')" validation-message-mode="always"
          validation-message-position="right">
          <DxValidator ref="validatorTipoPersona" validation-group="validacionTipoPersona">
            <DxCustomRule :validation-callback="validarTipoPersona"
              :message="$t('servicio_energia.form.validacion.tipo_persona')" :reevaluate="true" />
          </DxValidator>
        </DxCheckBox>
        <DxLabel :visible="false" />
      </DxSimpleItem>
      <DxEmptyItem :col-span="2">
      </DxEmptyItem>
      <DxSimpleItem data-field="Observaciones" :col-span="6">
        <DxLabel :text="$t('servicio_energia.form.observaciones')" />
        <DxTextArea v-model="props.model!.Observaciones" :height="100" />
      </DxSimpleItem>
    </DxGroupItem>
  </DxForm>
</template>

<script setup lang="ts">
import {
  DxForm,
  DxLabel,
  DxColCountByScreen,
  DxRequiredRule,
  DxEmptyItem,
  DxCompareRule,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";
import DxValidator, { DxCustomRule } from 'devextreme-vue/validator';
import { DxCheckBox, DxTextArea, DxDateBox } from "devextreme-vue";
import { type CreateServicioEnergiaModel, type DetailServicioEnergiaModel } from '@/.shared/.api';
import { getLookup } from '@/.shared/helpers/grid-helper';
import { watch } from 'vue';
import { useIntl } from '@/.shared/services/i18n';
import validationEngine from 'devextreme/ui/validation_engine';

const intl = useIntl();

const props = defineProps({
  model: {
    type: Object as () => DetailServicioEnergiaModel | CreateServicioEnergiaModel,
    required: true
  },
  tieneTramitesAsociados: {
    type: Boolean,
    required: true
  }
})

const selectTipoEnergia = { ...getLookup('servicios', 'tipo_energia'), disabled: props.tieneTramitesAsociados };

function fechaInicio() {
  return props.model.FechaInicio;
}

const costeNumberOptions = {
  showSpinButtons: true,
  step: 0.01,
  format: {
    type: "fixedPoint",
    precision: 4,
    formatter: (value: number) => {
      return intl.i18n.n(Number(value.toFixed(4)), 'decimal') + ' €/mes';
    }
  },
  disabled: props.tieneTramitesAsociados
};

watch(
  () => ({
    aplicaPersonaFisica: props.model.AplicaPersonaFisica,
    aplicaPersonaJuridica: props.model.AplicaPersonaJuridica
  }),
  () => {
    validationEngine.validateGroup("validacionTipoPersona");
  }
)

watch(
  () => ({
    fechaInicio: props.model.FechaInicio,
    fechaFin: props.model.FechaFin
  }),
  () => {
    validationEngine.validateGroup("validacionFechaFin");
  }
)

const descripcionOptions = {
  disabled: props.tieneTramitesAsociados,
  height: 100
}

const validarTipoPersona = (params: any) => {
  return props.model.AplicaPersonaFisica || props.model.AplicaPersonaJuridica || params.value;
};

</script>

<style scoped lang="scss">

.info-icon {
  margin-left: auto;
  font-size: 14px;
  cursor: pointer;
  position: relative;
}

.tooltip {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--background-normal-dark);
  color: var(--text-default-inverse);
  padding: 5px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

:deep(.activa-checkbox) {
  margin-top: 30px;
}

:deep(.excluyente-checkbox) {
  margin-top: 25px;
}
</style>